import '@ant-design/v5-patch-for-react-19';
import 'antd/dist/reset.css';

import { App, ConfigProvider } from 'antd';
import ru from 'antd/locale/ru_RU';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { PageError } from '@/pages/PageError/PageError';
import { useAppNotification } from '@/shared/hooks/useAppNotification';

import { setNotificationHandler } from './api/baseApi';
import { createAppRouter } from './router/Router';
import { store } from './store';

const AppInitializer = ({ children }: { children: React.ReactNode }) => {
  const { showError } = useAppNotification();

  React.useEffect(() => {
    setNotificationHandler((message, description) => {
      showError(message, description);
    });
  }, [showError]);

  return <>{children}</>;
};

const router = createAppRouter();

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider locale={ru}>
      <Provider store={store}>
        <ErrorBoundary fallback={<PageError isNotFound={false} />}>
          <App>
            <AppInitializer>
              <RouterProvider router={router} />
            </AppInitializer>
          </App>
        </ErrorBoundary>
      </Provider>
    </ConfigProvider>
  </React.StrictMode>,
);
